import { setBreadcrumbTitle } from "features/breadcrumb/breadcrumbSlice";
import React, { useEffect, useLayoutEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import { smallShadow, Spacer } from "theme/GlobalElements";
import { colors } from "theme/Theme";
import CartItems from "./CartItems";
import { selectCurrentStep, setCurrentStep } from "./cartSlice";
import DeliveryInformation from "./components/DeliveryInformation";
import OrderSuccess from "./components/OrderSuccess";
import ProgressBar from "./ProgressBar";

const componentsBySteps = (
  step: number,
  element: HTMLHeadingElement | null
) => {
  element && element.scrollIntoView();
  switch (step) {
    case 1:
      return <CartItems />;
    case 2:
      return <DeliveryInformation />;
    case 3:
      return <OrderSuccess />;
    default:
      return <div>Error</div>;
  }
};

const Cart = () => {
  const currentStep = useSelector(selectCurrentStep);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const refTitle = useRef<HTMLHeadingElement>(null);
  useLayoutEffect(() => {
    dispatch(setBreadcrumbTitle("Количка"));
    return () => {
      dispatch(setBreadcrumbTitle(""));
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(setCurrentStep(1));
  }, []);

  return (
    <CartContainer>
      <StyledH2 ref={refTitle}>Количка</StyledH2>
      <Content>
        <ProgressBar />
        <Spacer />
        {componentsBySteps(currentStep, refTitle.current)}
        {currentStep === 3 && (
          <FinalButton>
            <Button className="final-button" onClick={() => navigate("/")}>
              <span>Обратно към пазаруването</span>
            </Button>
          </FinalButton>
        )}
      </Content>
    </CartContainer>
  );
};

const CartContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 10px;

  @media only screen and (${device.laptop}) {
    margin: 20px;
  }
`;

const StyledH2 = styled.h2`
  color: black;
  align-self: flex-start;
`;

const Content = styled.div`
  width: 100%;
  margin-bottom: 12px;

  @media only screen and (${device.laptop}) {
    margin-top: 20px;
  }
`;

const Buttons = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
  margin: 15px 0;

  @media only screen and (${device.laptop}) {
    margin: 25px 0;
  }
`;

const FinalButton = styled(Buttons)`
  justify-content: center;
`;

const Button = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding: 5px 10px;
  cursor: pointer;
  ${smallShadow}

  &:nth-child(1) {
    margin-right: 10px;
  }

  &.back-button {
    background-color: white;
    outline: 1px solid ${colors.lighter_blue};
    color: ${colors.lighter_blue};
  }

  &.next-step-button,
  &.final-button {
    background-color: ${colors.lighter_blue};
    color: white;
  }

  &.final-button {
    justify-self: center;
  }

  @media only screen and (${device.laptop}) {
    padding: 10px 20px;
  }
`;

export default Cart;
